<template>

    <div v-if="data" :class="[{ 'proportional': settings.isProportional }, 'contentWrapper previewContainer']"
        :style="{ width: settings.width + '%' }">

        <div class="prop-wrap">

            <!-- @click="goToProduct()" title="Klick, um zur Seite des Produkts zu gelangen" -->
            <div :class="[{ 'bordered': settings.isBordered }, 'prop-inner']">

                <!-- Störer -->
                <!--
                <div class="stoerer" v-if="displayType!='NEU_AM_MARKT' && displayType != 'HAUSAPOTHEKE' && hasCoupon && activeUser.userRole.name != 'Industriepartner'">
                    <div class="stoererText">- {{ stoererText }} €</div>
                </div>
                -->

                <!-- Placement Code -->
                <div class="placementCode" v-if="data.placementCode != null">
                    {{ data.placementCode }}
                </div>

                <!-- Image -->
                <template v-if="!isPrint">
                    <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getAsset"></div>
                </template>

                <template v-else>
                    <!-- <div class="imgWrapper"><img v-lazy="getAsset" /></div> -->
                    <div class="imgWrapper"><img :src="getAsset" /></div>
                </template>

                <!-- Header -->
                <div class="contentHeader">
                    <h1 v-if="displayType == 'NEU_AM_MARKT'" class="title" v-html="data.neuAmMarktTitle"></h1>
                    <h1 v-else-if="displayType == 'HAUSAPOTHEKE'" class="title" v-html="data.hausapoTitle"></h1>
                    <h1 v-else class="title" v-html="data.title"></h1>
                </div>

                <!-- BODY -->
                <template v-if="displayType == 'NEU_AM_MARKT'">
                    <div class="contentBody" :style="'max-height: ' + previewContainerContentMaxHeight + '%;'"
                        v-html="data.neuAmMarktText"></div>
                </template>
                <template v-else-if="displayType == 'HAUSAPOTHEKE'">
                    <div class="contentBody" :style="'max-height: ' + previewContainerContentMaxHeight + '%;'"
                        v-html="data.hausapoText"></div>
                </template>
                <template v-else>
                    <div class="contentBody" :style="'max-height: ' + previewContainerContentMaxHeight + '%;'"
                        v-html="data.description"></div>
                </template>


                <!-- Product Variants -->
                <div class="productViewVariants"
                    v-if="displayType != 'NEU_AM_MARKT' && displayType != 'HAUSAPOTHEKE' && data.productVariants && data.productVariants.length > 0">

                    <h4 v-html="data.displayName"></h4>

                    <div class="productVariantsColumnsContainer">

                        <!-- <div class="columns" :class="{'is-multiline': variant.voucher && variant.voucher.discount > 0}" v-for="variant in data.productVariants"> -->
                        <div v-for="variant in data.productVariants"
                            :class="['columns is-multiline', { 'is-red': productType.includes('MEDICINAL') && ((variant.voucher && variant.voucher.discount) || isSpecialCoupon(variant)) }]"
                            :key="variant.id">

                            <div class="column is-9">{{ variant.name }}</div>
                            <div class="column is-3 price">

                                <template
                                    v-if="productType && productType.includes('MEDICINAL') && ((variant.voucher && variant.voucher.discount) || isSpecialCoupon(variant))">

                                    <template v-if="isSpecialCoupon(variant)">
                                        € {{ endpriceSpecialVoucher(variant.price,
                                        currentProductVoucherProductVariant.discount) }}
                                    </template>

                                    <!--
                                <template v-else-if="variant.voucher && variant.voucher.discount > 0 && activeUser.userRole.name != 'Industriepartner'">
                                  € {{ endprice(variant) }}
                                </template>
                                -->
                                    <template v-else-if="variant.voucher && variant.voucher.discount > 0">
                                        € {{ endprice(variant) }}
                                    </template>

                                </template>

                                <template v-else>
                                    € {{ pointToComma(variant.price) }}
                                </template>


                            </div>

                            <div class="column is-12 variantVoucher">

                                <template
                                    v-if="productType && productType.includes('MEDICINAL') && ((variant.voucher && variant.voucher.discount) || isSpecialCoupon(variant))">

                                    <template v-if="isSpecialCoupon(variant)">
                                        Preis gültig bis
                                        <!-- {{ formatDate2(productVoucherExpirationDate, false) }} -->

                                        <!--
                                    {{ formatDate2(currentCatalog.catalogProductVoucherExpirationDates.find((expDate) => expDate.id == currentProductVoucherProductVariant.catalogProductVoucherExpirationDate).expirationDate, false) }}
                                    -->
                                        <template v-if="productVoucherExpirationDate">Preis gültig bis {{
                                            formatDate2(productVoucherExpirationDate, false) }}</template>

                                    </template>

                                    <template v-else>
                                        <!-- Preis gültig bis {{ formatDate2(variant.voucher.catalogProductVoucherExpirationDate.expirationDate, false) }} -->
                                        <template v-if="productVoucherExpirationDate">Preis gültig bis {{
                                            formatDate2(productVoucherExpirationDate, false) }}</template>

                                    </template>

                                </template>

                                <template v-else>

                                    <template v-if="isSpecialCoupon(variant)">
                                        Mit Gutschein <span>€ {{
                                            showDiscount(currentProductVoucherProductVariant.discount) }} </span> sparen
                                    </template>

                                    <template v-else-if="variant.voucher && variant.voucher.discount > 0">
                                        Mit Gutschein <span>€ {{ showDiscount(variant.voucher.discount) }}</span> sparen
                                    </template>

                                </template>


                            </div>

                        </div>

                    </div>

                    <div class="productPriceSupplement" v-if="data.priceSupplement != ''">
                        {{ data.priceSupplement }}
                    </div>

                    <div class="productType" v-if="data.type">
                        <span></span>
                        {{ $t('PRODUCT_TYPE-' + productType) }}
                    </div>

                </div>
                <!--
                <div v-else-if="displayType != 'NEU_AM_MARKT' && displayType != 'HAUSAPOTHEKE'">
                    <div class="productType" v-if="data.type">
                        <span></span>
                        {{ $t('PRODUCT_TYPE-' + productType) }}

                    </div>
                </div>
                -->

                <div v-else>
                    <div class="productType" v-if="data.type">
                        <span></span>
                        {{ $t('PRODUCT_TYPE-' + productType) }}
                    </div>
                </div>

                <!-- FOOTER -->
                <!--
                <div class="contentFooter">

                    <div class="productPriceSupplement" v-if="data.priceSupplement != ''">
                        {{ data.priceSupplement }}
                    </div>

                    <div class="productType" v-if="data.type">
                        <span></span>
                        {{ getProductType }}
                    </div>

                </div>
                -->

                <!-- DISCLAIMER -->
                <div class="disclaimer" v-if="productType" :key="productType">
                    <lang :labelKey="productTypes[productType].data.label" v-if="productTypes[productType].data != null"></lang>
                </div>

            </div>

        </div>

    </div>

</template>


<script>

export default {


    props: {
        data: {
            type: Object,
            default: {}
        },
        displayType: {
            type: String,
            default: 'PRODUKT',
        },
        settings: {
            type: Object,
            default: {}
        },
        isPrint: {
            type: Boolean,
            default: false
        },

    },

    data() {

        return {
            stoererText: 0,
            currentProductVoucherProductVariant: null,
            previewContainerContentMaxHeight: 10,
        }
    },

    created() {

        // console.log(this.data.productVariants);
        $('.contentWrapper').flowtype({
            minFont: 2,
            fontRatio: 20
        });

    },

    mounted() {

        $('.contentWrapper').flowtype({
            minFont: 2,
            fontRatio: 20
        });

        let x = $('.previewContainer .imgWrapper').height() + $('.previewContainer .contentHeader').height() + $('.previewContainer .productViewVariants').height() + $('.previewContainer .disclaimer').height();
        this.previewContainerContentMaxHeight = 93.5 - x / $('.previewContainer .prop-inner').height() * 100;

    },

    updated() {

        $('.contentWrapper').flowtype({
            minFont: 2,
            fontRatio: 20
        });

        // let x = $('.previewContainer .imgWrapper').height() + $('.previewContainer .contentHeader').height() + $('.previewContainer .productViewVariants').height() + $('.previewContainer .disclaimer').height();

        let imageHeight = typeof $('.previewContainer .imgWrapper').height() != 'undefined' ? $('.previewContainer .imgWrapper').height() : 0;
        let headerHeight = typeof $('.previewContainer .contentHeader').height() != 'undefined' ? $('.previewContainer .contentHeader').height() : 0;
        let variantsHeight = typeof $('.previewContainer .productViewVariants').height() != 'undefined' ? $('.previewContainer .productViewVariants').height() : 0;
        let disclaimerHeight = typeof $('.previewContainer .disclaimer').height() != 'undefined' ? $('.previewContainer .disclaimer').height() : 0;

        // x = imageContainer + Header + productVarianten + Disclaimer
        let x = imageHeight + headerHeight + variantsHeight + disclaimerHeight;
        this.previewContainerContentMaxHeight = 93.5 - x / $('.previewContainer .prop-inner').height() * 100;

    },


    computed: {

        currentCatalog() {
            return this.$store.getters.getCurrentCatalog;
        },

        productVoucherExpirationDate() {
            // console.log("productVoucherExpirationDate: ", this.currentCatalog.catalogProductVoucherExpirationDates);
            return this.currentCatalog.catalogProductVoucherExpirationDates.length ? this.currentCatalog.catalogProductVoucherExpirationDates[0].expirationDate : null;
        },

        contentElementTypes() {
            return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_TYPES');
        },

        productDisplayTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_DISPLAY_TYPES');
        },

        productTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_TYPES');
        },
        productTypesRaw() {
            return this.$store.getters.getTermsByTaxonomyRaw('PRODUCT_TYPES');
        },

        productType() {

            /*
            for (var key in this.productTypes) {
                if (this.productTypes.hasOwnProperty(key) && this.productTypes[key].id == parseInt(this.data.type)) {
                    // this.productType = this.productTypes[key].name;
                    // return this.$t('PRODUCT_TYPE-' + this.productTypes[key].name);
                    return this.productTypes[key].name;
                }
            }
            */
            if(this.data.type) {
                return this.productTypesRaw.filter((type) => type.id == this.data.type)[0].name;
            }

        },

        productTypeLabeled() {
            return this.$t('PRODUCT_TYPE-' + this.productType);
        },

        productAssetTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_ASSET_TYPES');
        },

        getAsset() {

            var foundCoupons = [];
            var foundDefaults = [];

            if (this.data.productAssets !== undefined && this.data.productAssets.length > 0) {

                // Bei Coupon-Darstellung das Bild vom Typ „Coupon“ verwenden,
                // oder - wenn nicht vorhanden - das Bild mit Typ „Default“;
                for (var i = 0; i < this.data.productAssets.length; i++) {

                    if (this.data.productAssets[i].type == this.productAssetTypes.COUPON.id) {
                        foundCoupons.push(i);
                    }
                    else if (this.data.productAssets[i].type == this.productAssetTypes.DEFAULT.id) {
                        foundDefaults.push(i);
                    }
                }

            }

            if (foundDefaults.length > 0 && this.data.productAssets[foundDefaults[0]].asset != null) {
                return this.$config.assets + this.data.productAssets[foundDefaults[0]].asset.path + "/" + this.data.productAssets[foundDefaults[0]].asset.filename;
            }
            if (foundCoupons.length > 0 && this.data.productAssets[foundCoupons[0]].asset != null) {
                return this.$config.assets + this.data.productAssets[foundCoupons[0]].asset.path + "/" + this.data.productAssets[foundCoupons[0]].asset.filename;
            }

            return '';

        },

        hasCoupon() {

            // if there is a "special coupon", take this as "störer"
            if (this.currentProductVoucherProductVariant != null) {

                if (this.currentProductVoucherProductVariant.discount != parseInt(this.currentProductVoucherProductVariant.discount)) {
                    this.stoererText = this.currentProductVoucherProductVariant.discount.toString().replace(".", ",");
                } else {
                    this.stoererText = parseInt(this.currentProductVoucherProductVariant.discount);
                }

                return true;

            }

            if (this.data.productVariants != null && this.data.productVariants.length > 0) {
                for (var i = 0; i < this.data.productVariants.length; i++) {

                    if (this.data.productVariants[i].voucher != null && this.data.productVariants[i].voucher.discount != null) {

                        if (this.data.productVariants[i].voucher.discount != parseInt(this.data.productVariants[i].voucher.discount)) {
                            this.stoererText = this.data.productVariants[i].voucher.discount.toString().replace(".", ",");
                        } else {
                            this.stoererText = parseInt(this.data.productVariants[i].voucher.discount);
                        }

                        return true;

                    }
                }
            }

            return false;

        },

    },

    methods: {

        showDiscount(discount) {

            if (discount == "" || discount == null) {
                return 0;
            }

            if (discount == parseInt(discount)) {
                return parseInt(discount) + ',–';
            }

            if (discount.indexOf('.') > -1) {
                return discount.toString().replace(".", ",");
            }

            return discount;

        },
        
        goToProduct() {

            // only redirect if we're on a catalogPageElement site
            if (this.$route.name != 'catalogPageElement') {
                return;
            }

            this.$router.push('/products/product-' + this.data.id);

        },

        isSpecialCoupon(voucher) {

            if (this.data.productVouchers == null || this.data.productVouchers.length == 0) {
                return false;
            }

            for (var i = 0; i < this.data.productVouchers.length; i++) {

                if (this.data.productVouchers[i].productVoucherProductVariants.length > 0) {

                    for (var j = 0; j < this.data.productVouchers[i].productVoucherProductVariants.length; j++) {

                        if (this.data.productVouchers[i].productVoucherProductVariants[j].productVariant == voucher.id) {
                            this.currentProductVoucherProductVariant = this.data.productVouchers[i];
                            return true;
                        }
                    }

                }

            }

        },

        pointToComma(string) {

            return string.toString().replace(".", ",");

        },

        endpriceSpecialVoucher(variantPrice, specialDiscount) {

            if (variantPrice != null && specialDiscount != '') {

                var endprice = (parseFloat((variantPrice).replace(",", ".")) - parseFloat((specialDiscount).replace(",", "."))).toFixed(2).toString();

                if (endprice.indexOf('.') > -1) {
                    return endprice.toString().replace(".", ",");
                }

                return endprice;

            } else {

                return variantPrice;

            }

        },


        endprice(variant) {

            if (variant.voucher.discount != null && variant.voucher.discount != '') {

                var endprice = (parseFloat((variant.price).replace(",", ".")) - parseFloat((variant.voucher.discount).replace(",", "."))).toFixed(2).toString();

                if (endprice.indexOf('.') > -1) {
                    return endprice.toString().replace(".", ",");
                }

                return endprice;

            } else {

                return variant.price;

            }

        }

    }


}

</script>



<style scoped>
.lazy-img-fadein[lazy=loading] {
    background-position: 50% 50% !important;
    background-size: 30% !important;
}

.previewContainer .stoerer {
    position: absolute;
    z-index: 9;
    background: transparent url(../../../assets/img/produktcoupons_wischer_kurz.png) center center no-repeat;
    background-size: contain;
    z-index: 9;
    left: 2%;
    top: 0;
    width: 35%;
    padding-bottom: 35%;
    height: 0;
}

.previewContainer .stoererText {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    width: 100%;
    height: 100%;
    font-size: 150%;
    color: #eee;
    -moz-transform: rotate(-19deg);
    -ms-transform: rotate(-19deg);
    -o-transform: rotate(-19deg);
    -webkit-transform: rotate(-19deg);
    transform: rotate(-19deg);
}

.previewContainer h1 {
    white-space: normal;
}

.previewContainer .contentBody {
    white-space: normal;
    font-family: inherit;
    min-height: 20%;
    height: auto;
    /*max-height: 40%;*/
    margin: 0 0 5% 0;
    overflow: hidden;
    /*font-size: 93%;
        line-height: 125%;
        */
    font-size: 90%;
    line-height: 122%;
}

.previewContainer .contentFooter {
    position: relative;
    margin: 0 !important;
    /*
        min-height: 15%;
        max-height: 20%;
        */
    overflow: hidden;
}

.previewContainer .imgWrapper {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 5% auto 3% auto;
    height: 22% !important;
    text-align: center;
    width: 100% !important;
    max-width: 95%;

    border: 0 !important;
}

.previewContainer .imgWrapper img {
    height: 100%;
    width: auto;
    margin: 0 auto;
}

/*
    .productViewVariants {
        max-height: 20%;
        overflow: hidden;
    }
    */

.productViewVariants h4 {
    font-size: 100%;
    margin: 0 0 2% 0;
    white-space: normal;
    line-height: 110%;
}

.productViewVariants .productVariantsColumnsContainer {
    border-top: 1px solid #888;
    border-bottom: 1px solid #ccc;
    padding: 1% 0;
    margin: 0 0 1% 0;
}

.productVariantsColumnsContainer>.columns {
    margin: 0;
    padding: 0;
}

.productVariantsColumnsContainer .columns .column {
    padding: 0 !important;
    margin: 0 !important;
    font-size: 70%;
    line-height: 140% !important;
}

.productVariantsColumnsContainer>.columns .column.price {
    text-align: right;
}

/*
    .productVariantsColumnsContainer .columns .column.variantVoucher {
        font-size: 68% !important;
        padding: 0 0 0 4% !important;
        color: orange;
    }
    .variantVoucher span {
        float: right;
    }
    */
.productVariantsColumnsContainer .columns.is-red .column {
    color: #e20000;
}

.productVariantsColumnsContainer .columns .column.variantVoucher {
    font-size: 68% !important;
    padding: 0 0 0 4% !important;
    color: #e20000;
}


.disclaimer {
    position: absolute;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    padding: 4%;
    font-size: 50%;
    white-space: normal;
    line-height: 1.4em;
}

.productPriceSupplement {
    margin: 0;
    text-transform: none;
    text-align: right;
    font-size: 50%;
}
</style>
